<div class="subscription-comparison">
  <!-- Comparison Table -->
  <div class="comparison-table">
    <!-- Header Row -->
    <div class="header-row">
      @if (customMessage) {
        <div class="custom-message">
          <p [innerHTML]="customMessage"></p>
        </div>
      } @else {
        <div class="feature-column header-spacer"></div>
      }
      @for (tier of data.tiers; track tier.id) {
        <div class="tier-column tier-header">
          <p class="tier-name text-body-m">{{ tier.name }}</p>
          <p class="tier-price text-body-s">{{ tier.price }}</p>
        </div>
      }
    </div>

    <!-- Feature Rows -->
    @for (feature of data.features; track feature.id) {
      <div class="feature-row" [class.highlighted]="feature.highlighted">
        <div class="feature-column feature-description">
          <p class="text-body-m">{{ feature.description }}</p>
        </div>

        <!-- Free Tier Column -->
        <div class="tier-column feature-availability">
          @if (feature.availableInFree) {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="check-icon"
            >
              <path
                d="M16.6663 5L7.49967 14.1667L3.33301 10"
                stroke="#24AA85"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          } @else {
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="x-icon"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#385379"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        </div>

        <!-- Game Master Tier Column -->
        <div class="tier-column feature-availability">
          @if (feature.availableInGameMaster) {
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="check-icon"
            >
              <path
                d="M16.6663 5L7.49967 14.1667L3.33301 10"
                stroke="#24AA85"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          } @else {
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="x-icon"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#385379"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        </div>
      </div>
    }
  </div>

  <!-- Footnote and Upgrade Button -->
  @if (showUpgradeButton) {
    <div class="comparison-footer">
      @if (data.footnote) {
        <p class="footnote text-body-xs">{{ data.footnote }}</p>
      }
      <button
        type="button"
        class="upgrade-button text-body-l"
        (click)="onUpgrade()"
      >
        Become a Gamemaster now!
      </button>
    </div>
  }
</div>
